import { render, staticRenderFns } from "./ProductInstance.vue?vue&type=template&id=6cb3b318&"
import script from "./ProductInstance.vue?vue&type=script&lang=ts&"
export * from "./ProductInstance.vue?vue&type=script&lang=ts&"
import style0 from "./ProductInstance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports